import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { pickUpAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/PickUpAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

pickUpAddressStyles.headingGridItem = mergeToNew(pickUpAddressStyles.headingGridItem, {
    css: css`
        background: ${getColor("common.backgroundContrast")};
        padding: 15px 18px;
    `,
});

pickUpAddressStyles.findLocationLink = {
    css: css`
        margin-left: auto;
    `,
};
